import { Component, input, InputSignal } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
	selector: 'app-loader',
	imports: [SpinnerComponent],
	templateUrl: './loader.component.html',
	styleUrl: './loader.component.scss',
})
export class LoaderComponent {
	public loadingMessage: InputSignal<string> = input('');
}
